// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
// import * as bootstrap from "bootstrap"
import * as ActiveStorage from "@rails/activestorage";

ActiveStorage.start();
// window.bootstrap = bootstrap;

import "./src/zones";

ActiveStorage.start();

if (!window.Verifier) { window.Verifier = {} };
window.Verifier.authencityToken = document.querySelector('meta[name="csrf-token"]').content;

window.Version = "0.0.1";
